export const Eye = () => (
  <g>
    <path
      d='M12 7C8.81818 7 6.10091 9.07333 5 12C6.10091 14.9267 8.81818 17 12 17C15.1818 17 17.8991 14.9267 19 12C17.8991 9.07333 15.1818 7 12 7ZM12 15.3333C10.2436 15.3333 8.81818 13.84 8.81818 12C8.81818 10.16 10.2436 8.66667 12 8.66667C13.7564 8.66667 15.1818 10.16 15.1818 12C15.1818 13.84 13.7564 15.3333 12 15.3333ZM12 10C10.9436 10 10.0909 10.8933 10.0909 12C10.0909 13.1067 10.9436 14 12 14C13.0564 14 13.9091 13.1067 13.9091 12C13.9091 10.8933 13.0564 10 12 10Z'
      fill='currentColor'
    />
  </g>
)
